/* ============================================================
   Kisan Bahadur \u2014 theme interactions
   Scroll reveal \u00B7 hero rotator \u00B7 scroll progress \u00B7 count-up
   PDP gallery + variant + quantity \u00B7 header search toggle
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Scroll reveal + count-up ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1500, start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function setupReveal() {
    var revealEls = document.querySelectorAll('[data-reveal]');
    var countEls = document.querySelectorAll('[data-count]');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('kb-in'); });
      countEls.forEach(animateCount);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.hasAttribute('data-count')) { animateCount(el); }
        else { el.classList.add('kb-in'); }
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
    countEls.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      revealEls.forEach(function (el) { if (!el.classList.contains('kb-in')) el.classList.add('kb-in'); });
    }, 2600);
  }

  /* ---------- Scroll progress bar ---------- */
  function setupScroll() {
    var bar = document.getElementById('kb-progress');
    if (!bar) return;
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight || 1;
        var sc = Math.min(1, Math.max(0, h.scrollTop / max));
        bar.style.transform = 'scaleX(' + sc + ')';
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Hero image rotator ---------- */
  function setupHero() {
    var slides = document.querySelectorAll('.kb-hero__slide');
    if (slides.length < 2) return;
    var nameEl = document.getElementById('kb-hero-name');
    var priceEl = document.getElementById('kb-hero-price');
    var tagEl = document.getElementById('kb-hero-tag');
    var idx = 0;
    function render() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      var el = slides[idx];
      if (nameEl) nameEl.textContent = el.getAttribute('data-name') || '';
      if (tagEl) tagEl.textContent = el.getAttribute('data-tag') || '';
      if (priceEl) priceEl.innerHTML = (el.getAttribute('data-price') || '') +
        ' <span style="font-size:12px;color:var(--kb-faint);font-family:\'Hanken Grotesk\',sans-serif;">/ ' +
        (el.getAttribute('data-size') || '') + '</span>';
    }
    render();
    setInterval(function () { idx = (idx + 1) % slides.length; render(); }, 3200);
  }

  /* ---------- Header search toggle ---------- */
  function setupHeader() {
    var searchBtn = document.querySelector('[data-kb-search-toggle]');
    var panel = document.querySelector('[data-kb-search-panel]');
    if (searchBtn && panel) {
      searchBtn.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) { panel.removeAttribute('hidden'); var inp = panel.querySelector('input'); if (inp) inp.focus(); }
        else { panel.setAttribute('hidden', ''); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.setAttribute('hidden', ''); });
    }
    var menuBtn = document.querySelector('[data-kb-menu-toggle]');
    var mobileNav = document.querySelector('[data-kb-mobile-nav]');
    if (menuBtn && mobileNav) {
      menuBtn.addEventListener('click', function () {
        if (mobileNav.hasAttribute('hidden')) mobileNav.removeAttribute('hidden');
        else mobileNav.setAttribute('hidden', '');
      });
    }
  }

  /* ---------- PDP: gallery thumbs, variant select, quantity ---------- */
  function setupProduct() {
    var pdp = document.querySelector('[data-kb-pdp]');
    if (!pdp) return;

    // gallery (supports images, video, external video, 3D model)
    var mainMedia = pdp.querySelector('[data-kb-main-media]');
    pdp.querySelectorAll('[data-kb-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-media-id');
        var tpl = pdp.querySelector('template[data-kb-media-tpl="' + id + '"]');
        if (mainMedia && tpl) {
          // stop any currently-playing video before swapping it out
          var playingVideo = mainMedia.querySelector('video');
          if (playingVideo) { try { playingVideo.pause(); } catch (e) {} }
          mainMedia.innerHTML = '';
          mainMedia.appendChild(tpl.content.cloneNode(true));
        }
        pdp.querySelectorAll('[data-kb-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // variant buttons -> hidden select + price
    var variantInput = pdp.querySelector('[data-kb-variant-id]');
    var priceEl = pdp.querySelector('[data-kb-price]');
    var addLabel = pdp.querySelector('[data-kb-add-label]');
    var qtyInput = pdp.querySelector('[data-kb-qty]');

    function fmt(cents) {
      // Shopify money is in cents; format with rupee + grouping
      var n = (cents / 100);
      return '\u20B9' + n.toLocaleString('en-IN');
    }
    function currentUnit() {
      var active = pdp.querySelector('[data-kb-variant].is-active');
      if (active) return parseInt(active.getAttribute('data-price'), 10);
      return qtyInput ? parseInt(qtyInput.getAttribute('data-unit-price'), 10) || 0 : 0;
    }
    function refreshTotals() {
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (addLabel) addLabel.textContent = 'Add to cart \u2014 ' + fmt(currentUnit() * qty);
    }

    pdp.querySelectorAll('[data-kb-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        pdp.querySelectorAll('[data-kb-variant]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        if (variantInput) variantInput.value = b.getAttribute('data-variant-id');
        if (priceEl) {
          priceEl.firstChild && (priceEl.childNodes[0].nodeValue = fmt(parseInt(b.getAttribute('data-price'), 10)) + ' ');
          var small = priceEl.querySelector('small');
          if (small) small.textContent = '/ ' + b.getAttribute('data-title');
        }
        refreshTotals();
      });
    });

    if (qtyInput) {
      var dec = pdp.querySelector('[data-kb-qty-dec]');
      var inc = pdp.querySelector('[data-kb-qty-inc]');
      var disp = pdp.querySelector('[data-kb-qty-disp]');
      function setQty(v) { v = Math.max(1, v); qtyInput.value = v; if (disp) disp.textContent = v; refreshTotals(); }
      if (dec) dec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
      setQty(1);
    }
    refreshTotals();
  }

  /* ---------- init ---------- */
  function init() {
    setupReveal();
    setupScroll();
    setupHero();
    setupHeader();
    setupProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run reveal/hero when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function () { setupReveal(); setupHero(); setupProduct(); });
})();


/* ============================================================
   Cart drawer (Kisan Circle) \u2014 self-contained
   ============================================================ */
(function () {
  'use strict';
  /* ---------- Cart drawer ---------- */
  function setupCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    if (drawer.__kcBound) { if (drawer.__kcRefresh) drawer.__kcRefresh(); return; }
    drawer.__kcBound = true;

    var body = drawer.querySelector('[data-cart-body]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var grainsEl = drawer.querySelector('[data-cart-grains]');
    var shipWrap = drawer.querySelector('[data-cart-ship]');
    var shipTxt = drawer.querySelector('[data-cart-ship-txt]');
    var shipBar = drawer.querySelector('[data-cart-ship-bar]');
    var freeShip = parseInt(drawer.getAttribute('data-free-ship'), 10) || 0;
    var perHundred = parseInt(drawer.getAttribute('data-grains-per-100'), 10) || 0;

    function fmt(cents) { return '\u20B9' + (cents / 100).toLocaleString('en-IN'); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function open() { drawer.removeAttribute('hidden'); requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { drawer.setAttribute('hidden', ''); }, 400); }

    function setCount(n) {
      document.querySelectorAll('.kb-cart-count').forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? '' : 'none'; });
    }

    function render(cart) {
      setCount(cart.item_count);
      if (!cart.item_count) {
        body.hidden = true; foot.hidden = true; shipWrap.hidden = true; empty.hidden = false; return;
      }
      empty.hidden = true; body.hidden = false; foot.hidden = false;
      var html = '';
      cart.items.forEach(function (it) {
        var img = it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="kc-line__variant">' + esc(it.variant_title) + '</div>' : '<div style="height:6px;"></div>';
        html += '<div class="kc-line" data-key="' + it.key + '">' +
          '<a class="kc-line__img" href="' + it.url + '">' + img + '</a>' +
          '<div style="flex:1;min-width:0;">' +
            '<a class="kc-line__name" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
            variant +
            '<div class="kc-line__row">' +
              '<div class="kc-line__stepper">' +
                '<button type="button" data-step="-1" aria-label="Decrease">\u2212</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-step="1" aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" class="kc-line__remove" data-remove>Remove</button>' +
              '<span class="kc-line__price">' + fmt(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      body.innerHTML = html;
      totalEl.textContent = fmt(cart.total_price);

      if (grainsEl && perHundred) {
        var g = Math.floor(cart.total_price * perHundred / 10000);
        grainsEl.innerHTML = '\u25C8 You\'ll earn <b>' + g + ' grains</b> with this order';
      }
      if (shipWrap && freeShip) {
        if (cart.total_price >= freeShip) {
          shipWrap.hidden = false; shipTxt.innerHTML = '<b>Free shipping</b> unlocked \u2726'; shipBar.style.width = '100%';
        } else {
          shipWrap.hidden = false;
          shipTxt.innerHTML = 'You\'re <b>' + fmt(freeShip - cart.total_price) + '</b> away from free shipping';
          shipBar.style.width = Math.min(100, cart.total_price / freeShip * 100) + '%';
        }
      }
    }

    function refreshCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render).catch(function () {});
    }

    function change(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render).catch(function () {});
    }

    // close interactions
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    // line item qty / remove (delegated)
    body.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]'); if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.kc-line__stepper span');
      var cur = parseInt(qtyEl.textContent, 10) || 1;
      if (e.target.closest('[data-remove]')) { change(key, 0); }
      else if (e.target.closest('[data-step]')) {
        var d = parseInt(e.target.getAttribute('data-step'), 10);
        change(key, Math.max(0, cur + d));
      }
    });

    // intercept ALL add-to-cart form submits
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action$="/cart/add"], form#kb-add-form')) return;
      if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return; // let dynamic checkout through
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCart(); open(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
    });

    // cart icon opens the drawer instead of navigating
    document.querySelectorAll('a[href$="/cart"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refreshCart(); open(); });
    });

    refreshCart();
    drawer.__kcRefresh = refreshCart;
  }

  function boot() { setupCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', setupCart);
})();